<template>
  <div id='app'>
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style>
#app {
	position: relative;
	top: 0px;
	left: 0px;
	width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue